import { isLanguage } from '../../../../utils/language.mjs';
import { isStoreId } from '../../../../utils/storeId.mjs';
import { pathnameToParts, partsToPathname } from '../../../../utils/url.mjs';
"use strict";
const buildLanguageLink = (contextStoreId, languageKey, href) => {
  try {
    const currentURL = new URL(href || window.location.href);
    const pathParts = pathnameToParts(currentURL.pathname);
    const partsToRemove = (isStoreId(pathParts[0]) ? 1 : 0) + (isLanguage(pathParts[1]) ? 1 : 0);
    const restOfPath = pathParts.slice(partsToRemove);
    const newPathParts = [contextStoreId,
    // Use the storeId from the context
    languageKey, ...restOfPath];
    currentURL.pathname = partsToPathname(newPathParts);
    currentURL.searchParams.set("l", languageKey);
    return currentURL.toString().replace(currentURL.origin, "");
  } catch {
    console.log("I FALIED");
    return void 0;
  }
};
export { buildLanguageLink };
//# sourceMappingURL=buildLanguageLink.mjs.map
